import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import Swal from 'sweetalert2';

import {
  TerminalDataModel,
  TranslationsLibService,
  Breadcrumb,
  HelpersLibService,
  IrrigationService,
  ManualActivationsStopsPerWaterSystemDataModel,
  IrrigationEquipmentModel,
} from '@nutricontrol/app360-shared';

@Component({
  selector: 'app-manual-activations',
  templateUrl: './manual-activations.component.html',
  styleUrls: ['./manual-activations.component.scss'],
})
export class ManualActivationsComponent implements OnInit {
  @Input() terminal: TerminalDataModel;
  @Input() equipment: IrrigationEquipmentModel;
  public breadcrumbs: Breadcrumb[] = [];
  public terminalLoaded = false;
  public statusLoaded = false;
  public equipmentLoaded = false;
  public isConnected = false;
  private terminal_vid: string;
  public totalWaterSystems: number;
  public warp: number;
  public stopsPerWaterSystem: ManualActivationsStopsPerWaterSystemDataModel[];

  constructor(
    private router: Router,
    private translationsLib: TranslationsLibService,
    private activatedRoute: ActivatedRoute,
    private helpersLib: HelpersLibService,
    private irrigationService: IrrigationService
  ) {}

  ngOnInit() {
    const [, , terminal_vid] = this.router.url.split('/');
    this.terminal_vid = terminal_vid;
    this.setPageTitle();
    if (this.terminal) {
      this.terminalLoaded = true;
      this.generateBreadcrumbs();
    } else {
      this.getTerminal();
    }

    if (this.equipment) {
      this.isConnected = this.equipment.connected;
      this.equipmentLoaded = true;
    } else {
      this.getEquipment();
    }

    this.getStatus();
  }

  public waterSystemsArray() {
    return Array.from({ length: this.totalWaterSystems }, (_, i) => i);
  }

  public startFiltersCleaning(waterSystemId: number) {
    return this.irrigationService
      .postStartFiltersCleaning(this.terminal_vid, waterSystemId)
      .subscribe((_) => {
        Swal.fire({
          icon: 'success',
          text: this.translationsLib
            .get('manual_activations_start_filters_clean_sent')
            .replace(':waterSystem', (waterSystemId + 1).toString()),
          confirmButtonColor: '#224261',
        });
      });
  }

  public stopFiltersCleaning(waterSystemId: number) {
    return this.irrigationService
      .postStopFiltersCleaning(this.terminal_vid, waterSystemId)
      .subscribe((_) => {
        Swal.fire({
          icon: 'success',
          text: this.translationsLib
            .get('manual_activations_stop_filters_clean_sent')
            .replace(':waterSystem', (waterSystemId + 1).toString()),
          confirmButtonColor: '#224261',
        });
      });
  }

  public waterSystemLock(waterSystemId: number) {
    return this.irrigationService
      .postWaterSystemLock(this.terminal_vid, waterSystemId)
      .subscribe((_) => {
        Swal.fire({
          icon: 'success',
          text: this.translationsLib
            .get('manual_activations_lock_sent')
            .replace(':waterSystem', (waterSystemId + 1).toString()),
          confirmButtonColor: '#224261',
        });
      });
  }

  public isLocked(waterSystemId: number): boolean {
    const alarmFound = this.stopsPerWaterSystem.find((stopPerWaterSystem) => {
      return stopPerWaterSystem.water_system === waterSystemId;
    });

    if (alarmFound && alarmFound.status === true) {
      return true;
    }

    return false;
  }

  public reload() {
    this.statusLoaded = false;
    this.equipmentLoaded = false;
    this.getEquipment();
    this.getStatus();
  }

  private setPageTitle() {
    this.activatedRoute.paramMap.subscribe((_) => {
      this.helpersLib.setTitle(
        '',
        this.translationsLib.get('manual_activations'),
        null
      );
    });
  }

  private getTerminal() {
    this.irrigationService
      .getTerminal(this.terminal_vid)
      .subscribe((terminal) => {
        this.terminal = terminal;
        this.terminalLoaded = true;
        this.generateBreadcrumbs();
      });
  }

  private getEquipment() {
    this.irrigationService
      .getIrrigationTerminal(this.terminal_vid)
      .subscribe((equipment) => {
        this.equipment = equipment;
        this.isConnected = this.equipment.connected;
        this.equipmentLoaded = true;
      });
  }

  private getStatus() {
    this.irrigationService
      .getManualActivationStatus(this.terminal_vid)
      .subscribe(
        (manualActivationsResponse) => {
          this.totalWaterSystems =
            manualActivationsResponse.water_systems_count;
          this.warp = manualActivationsResponse.warp;
          this.stopsPerWaterSystem =
            manualActivationsResponse.stops_per_water_system;

          this.statusLoaded = true;
        },
        () => {
          Swal.fire({
            icon: 'success',
            text: this.translationsLib.get(
              'remote_control_has_connection_errors'
            ),
            confirmButtonColor: '#224261',
          }).then(() => {
            this.router.navigate([`/farming/${this.terminal.vid}/irrigation`]);
          });
        }
      );
  }

  private generateBreadcrumbs() {
    if (!this.terminal) {
      return;
    }
    this.breadcrumbs = [];
    if (this.terminal.field) {
      this.breadcrumbs.push({
        text: this.terminal.field.name,
        disabled: false,
        to: ['/field', { vid: this.terminal.field.vid }],
        active: false,
      });
    }
    this.breadcrumbs.push(
      {
        text: this.terminal.name,
        disabled: false,
        to: `/farming/${this.terminal.vid}/irrigation`,
        active: false,
      },
      {
        text: this.translationsLib.get('manual_activations'),
        disabled: false,
        active: true,
      }
    );
  }
}
